import type { NombreIcono } from '../componentes/iconos';

/**
 * Dibujo de cada clave semántica de icono del menú y de los accesos de Inicio (`NavigationIcon`, G97; lista en la ficha
 * del núcleo §13), con los iconos del prototipo 0.1. Una clave que el panel no conoce sale con un icono genérico (la API
 * puede traer módulos nuevos antes que el panel). Las del segundo bloque son las del prototipo para entradas que aún no
 * tienen fila en su ficha (pendiente de que cada módulo las declare con su clave).
 */
const DIBUJO: Readonly<Record<string, NombreIcono>> = {
    home: 'house',
    bookings: 'book-open',
    // De Reservas (G878): «Estancias»
    stays: 'bed-double',
    floor: 'map',
    customers: 'users',
    tickets: 'ticket',
    scanner: 'scan-line',
    inbox: 'mail',
    campaigns: 'send',
    floor_plan: 'grid-3x3',
    resources: 'armchair',
    channels: 'message-circle',
    business: 'settings',
    website: 'globe',
    payments: 'credit-card',
    // De Pagos, «Cobrar» en Operativa (G276)
    cash: 'hand-coins',
    account: 'user',
    setup: 'rocket',
    team: 'user-cog',
    billing: 'receipt',
    activity: 'history',
    // De Agenda y Disponibilidad (G244): «Horario» y la tarjeta «Cuándo se puede reservar»
    clock: 'clock',
    hourglass: 'hourglass',
    // De Entregas (G294): «Avisos» y «Mensajes», con guion bajo porque `NavigationIcon` no admite guiones
    bell_ring: 'bell-ring',
    message_square_text: 'message-square-text',
    // De Clientes (G141): los apartados de la barra
    duplicates: 'git-merge',
    import: 'upload',
    privacy: 'shield',
    tags: 'tags',
    // De Citas (G779): «Agenda» usa `agenda`, abajo; «Servicios y profesionales», el del prototipo 0.1
    services: 'tag',
    // De Eventos y Entradas y de Pases (G778): «Entradas» (Pedidos · Informes) y «Puerta»; `guest_lists` y `box_office`, abajo
    ticket_orders: 'ticket',
    door_open: 'door-open',
    // Del prototipo, pendientes de su ficha
    agenda: 'calendar-days',
    events: 'party-popper',
    guest_lists: 'list-checks',
    messages: 'message-square-text',
    box_office: 'banknote',
    door: 'door-open',
    indicators: 'chart-line',
    // De Analítica: «Indicadores» y su apartado «Exportaciones»
    chart_line: 'chart-line',
    download: 'download',
    notices: 'bell-ring',
    assistant: 'bot',
    schedule: 'clock',
    developers: 'code',
    add: 'plus',
    // Botones «Lo que Reservaria hace por ti» de Inicio (G800), que declara cada módulo
    message_circle: 'message-circle',
    shield_check: 'shield-check',
    send: 'send',
    globe: 'globe',
    list_checks: 'list-checks',
    qr_code: 'qr-code',
    map: 'map',
    message_circle_question: 'message-circle-question',
    calendar_clock: 'calendar-clock',
    alarm_clock: 'alarm-clock',
    // G924: «Citas por completar» (dibujo 7.1)
    circle_alert: 'circle-alert',
    // G960, G961: «Firmas en el centro» y «Tu agenda en la web» (dibujo 7.1)
    signature: 'signature',
    calendar_plus: 'calendar-plus',
    // Portal de partners (1.23): su menú es fijo (zona sin negocio, sin getMyNavigation); claves con guion bajo como las demás
    building_2: 'building-2',
    percent: 'percent',
    link: 'link',
    file_text: 'file-text',
};

export const ICONO_GENERICO: NombreIcono = 'layout-grid';

export function dibujoDe(clave: string): NombreIcono {
    return DIBUJO[clave] ?? ICONO_GENERICO;
}
